import { render, staticRenderFns } from "./BundleShares.vue?vue&type=template&id=7a5ac4c8&scoped=true"
import script from "./BundleShares.vue?vue&type=script&lang=js"
export * from "./BundleShares.vue?vue&type=script&lang=js"
import style0 from "./BundleShares.vue?vue&type=style&index=0&id=7a5ac4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5ac4c8",
  null
  
)

export default component.exports